<template>
  <div class="comment-block">
    <div class="comment-block__hash">#</div>
    <textarea-autosize class="comment-block__textarea" v-model="val.text" maxlength="640" rows="1"></textarea-autosize>
  </div>
</template>

<script>
export default {
  props: ['value', 'blockId'],
  data () {
    return {
      val: null
    }
  },
  created () {
    this.val = this.value
  },
  methods: {
    onInput () {
      this.$emit('input', this.val)
      this.$store.commit('SET_FLOW_EDIT_FLAG', [this.blockId, true])
      this.$store.commit('SET_EDITED', true)
    }
  }
}
</script>

<style lang="scss">
.comment-block {
  display: flex;
  align-items: center;
  width: 92%;

  &__hash {
    font-size: 2em;
    font-weight: 700;
    color: #c9c9c9;
    margin-right: 10px;
  }

  &__textarea {
    border: none;
    outline: none;
    background-color: transparent;
    margin-top: 4px;
    display: inline-block;
    vertical-align: middle;
    font-size: 1em;
    font-style: italic;
    width: 90%;
    color: #aaaaaa;
  }
}
</style>
